module.exports = __webpack_public_path__ + "static/media/cafe_noir_thumb.0e0fccaa.webp";